var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { attrs: { "data-aos": "fade-left" } }, [
        _vm._v(_vm._s(_vm.$t("ac_cleaning.why_clean_ac_section.title")))
      ]),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "sub-text py-2", attrs: { "data-aos": "fade-right" } },
        [_vm._v(_vm._s(_vm.$t("ac_cleaning.why_clean_ac_section.subtitle")))]
      ),
      _vm._v(" "),
      _vm._l(_vm.details, function(detail, index) {
        return _c("div", { key: index, staticClass: "details" }, [
          _c("img", { attrs: { src: "/static/img/acCleaning/svg/Check.svg" } }),
          _vm._v(" "),
          _c("p", {
            staticClass: "list",
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("ac_cleaning.why_clean_ac_section.benefits." + index)
              )
            }
          })
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f5d505c8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5d505c8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acCleaningRe/WhyAirCleaning.vue
// module id = 1580
// module chunks = 0